// Actions
export const MERGE_ENTITIES = 'MERGE_ENTITIES';

export const mergeEntities = (data, schemaMapping) => ({
    type: MERGE_ENTITIES,
    data,
    schemaMapping,
});
